import Layout from "@/components/app/Layout";

export default function About() {
  return (
    <Layout>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="meta-label mb-3">About</div>
        <h1 className="font-display text-4xl sm:text-6xl font-black tracking-tight">A quiet place for loud work.</h1>
        <div className="mt-10 space-y-6 text-base sm:text-lg text-muted-foreground leading-relaxed">
          <p>
            CREATIVE HUB is a community portfolio platform designed for animation, design, and art students to showcase their craft.
            We take artwork seriously — the UI steps aside so the work can breathe.
          </p>
          <p>
            Every creator gets a shareable portfolio at <span className="font-mono-u text-foreground">/u/your-handle</span>, a dashboard to manage work,
            and a feed of peers who care about the same craft you do.
          </p>
          <p>
            Built with intention. No noise. Just creative work and the people behind it.
          </p>
        </div>
      </section>
    </Layout>
  );
}
